import { useActions } from '@root/core/hooks/useActions';
import { useTypedSelector } from '@root/core/hooks/useTypedSelector';
import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import { inquiryInboundInfo } from '@root/state/reducers/Settlement/settlementReducer';
import { Button, Card, Col, Divider, Row } from 'antd';
import { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import CustomerIDInforComponent from '../../components/customerIDInfor';
import FromToInforComponent from '../../components/FromToInfor';
import InqueryHistory from '../../components/InqueryHistory';
import settlementService from '../../Services/settlementService';
interface ParamType {
  id: string;
}
const Breadcrumb = [
  {
    tittle: 'Settlement',
    url: ''
  },
  {
    tittle: 'Service Inquiry',
    url: '/admin/serviceInquiry'
  },
  {
    tittle: 'Service Inquiry (Detail)',
    url: ''
  }
];

function ServiceInquiryDetailPage() {
  const { id } = useParams<ParamType>();
  const { search } = useLocation();
  const { getServiceDetail } = useActions();
  const [isDisable, setIsDisable] = useState<boolean>(false);
  useEffect(() => {
    getServiceDetail(id);
  }, []);

  const { detail, loading } = useTypedSelector(
    (state) => state.billingInquiryDetailReducer
  );

  useEffect(() => {
    CaptureOrders();
  }, [detail]);

  const CaptureOrders = async () => {
    if (
      !!search &&
      !!detail?.serviceStatus &&
      detail?.serviceStatus !== 'Completed' &&
      search.includes('paymentStatus=Success')
    ) {
      let params = search.replace('?', '').split('&');
      let paramUse: any = [];
      params.forEach((x, n) => {
        let t = x.split('=');
        paramUse = [...paramUse, ...[t]];
      });
      let body = Object.fromEntries(paramUse);
      body.inquiryId = id;
      body.payerID = body.PayerID;
      delete body.PayerID;
      delete body.paymentStatus;
      await settlementService.CaptureOrder(body);
      setIsDisable(true);
    }
  };
  // info Ids
  const infoIds = {
    receiptId: detail?.receiptId,
    customerId: detail?.seller.email,
    warehouseId: detail?.warehouse.email,
    paypalOrderId: detail?.paypalOrderId
  };
  const fromToInfo = {
    seller: detail?.seller,
    warehouse: detail?.warehouse,
    admin: detail?.admin,
    service: true
  };

  // Inquiry history
  const inquiryHistory: inquiryInboundInfo = {
    numberDelivered: detail?.numberDelivered ? detail?.numberDelivered : 0,
    numberDisposal: detail?.numberDisposal ? detail?.numberDisposal : 0,
    numberProductTypes: detail?.numberProductTypes
      ? detail?.numberProductTypes
      : 0,
    numberReturn: detail?.numberReturn ? detail?.numberReturn : 0,
    orderCounts: detail?.orderCounts ? detail?.orderCounts : 0,
    warehouse: detail?.warehouse
  };

  // detail dates
  const dates = {
    startDate: detail?.periodStart ? detail?.periodStart : 0,
    endDate: detail?.periodEnd ? detail?.periodEnd : 0
  };

  const getDate = (startDate?: string, endDate?: string) => {};
  return (
    <div>
      <BreadcrumbList listBreadcrumb={Breadcrumb} />
      <div className="billingDetail">
        <Row gutter={40} style={{ marginBottom: '35px' }}>
          <Col span={10}>
            <Card style={{ height: '100%' }}>
              <CustomerIDInforComponent infoIds={infoIds} />
            </Card>
          </Col>
          <Col span={14}>
            <Card>
              <FromToInforComponent fromToInfo={fromToInfo} />
            </Card>
          </Col>
        </Row>
        <Card style={{ padding: '20px' }}>
          <InqueryHistory
            idCustomer={id}
            inquiryHistory={inquiryHistory}
            dates={dates}
            getDate={getDate}
          />
          <Row>
            <Col span={6}>
              <h2>Billing amount</h2>
            </Col>
            <Col span={16}>
              <Divider dashed style={{ borderWidth: '2px 0 0' }} />
            </Col>
            <Col span={3} align="right">
              <p style={{ fontSize: '20px' }}>US$ {detail?.billingAmount} </p>
            </Col>
            <Col span={6}>
              <h2 style={{ marginBottom: '0', fontSize: '30px' }}>
                Total Payment
              </h2>
            </Col>
            <Col span={14}>
              <Divider dashed style={{ borderWidth: '2px 0 0' }} />
            </Col>
            <Col span={6} align="right">
              <p
                style={{
                  marginBottom: '0',
                  fontSize: '25px',
                  fontWeight: 'bolder'
                }}
              >
                US$ {detail?.serviceAmount}
              </p>
            </Col>
            <Col span={8} className="billingAmount">
              <p>12% of Billing amount </p>
            </Col>
          </Row>
          <Row>
            <Col span={24} align="right">
              <Button
                style={{
                  background:
                    detail?.serviceStatus === 'Completed'
                      ? '#f5f5f5'
                      : '#2b2c51',
                  color:
                    detail?.serviceStatus === 'Completed'
                      ? 'rgba(0,0,0,.25)'
                      : '#fff'
                }}
                className="confirm"
                disabled={
                  detail?.serviceStatus === 'Completed' ||
                  !detail?.paypalApproveUrl ||
                  isDisable
                }
                onClick={() => {
                  window.location.href = detail?.paypalApproveUrl;
                }}
              >
                Pay to Paypal
              </Button>
            </Col>
          </Row>
        </Card>
      </div>
    </div>
  );
}

export default ServiceInquiryDetailPage;
